<ion-card class="c-card c-card--min-height">
  <section class="success-message">
    <app-image
      class="success-message__tick"
      src="assets/icon/success-tick.svg"
      [alt]="'ALT_IMG.SUCCESS_TICK' | translate"
    ></app-image>
    <h4 class="success-message__title">
      {{ 'LOGS.NEGATIVE_BALANCE.THANKS' | translate }}
    </h4>
    <p class="success-message__desc">
      {{ 'LOGS.NEGATIVE_BALANCE.SUCCESS' | translate }}
    </p>
  </section>
</ion-card>
